import { z } from "zod";
/** Yıkama (Prompt 18, ADR 0018) — sabit listeler ve Türkçe etiketleri. */
export const WASH_START_MODES = ["REMOTE", "CODE", "MANUAL"];
export const washStartModeSchema = z.enum(WASH_START_MODES);
export const WASH_START_MODE_LABELS = {
    REMOTE: "Uzaktan başlatma (ajan)",
    CODE: "Başlatma kodu",
    MANUAL: "Elle (entegrasyon yok)",
};
export const WASH_PROGRAM_KINDS = ["AUTOMATIC", "SELF_SERVICE", "HAND_WASH"];
export const washProgramKindSchema = z.enum(WASH_PROGRAM_KINDS);
export const WASH_PROGRAM_KIND_LABELS = {
    AUTOMATIC: "Otomatik makine",
    SELF_SERVICE: "Self-servis (süre kredisi)",
    HAND_WASH: "El yıkama / detaylı temizlik",
};
export const WASH_CYCLE_TRIGGERS = ["POS", "CODE", "CREDIT", "REMOTE", "MACHINE_PAYMENT", "MANUAL"];
export const washCycleTriggerSchema = z.enum(WASH_CYCLE_TRIGGERS);
export const WASH_CYCLE_TRIGGER_LABELS = {
    POS: "Kasadan başlatma",
    CODE: "Başlatma kodu",
    CREDIT: "Self-servis kredisi",
    REMOTE: "Uzaktan (uygulama / web)",
    MACHINE_PAYMENT: "Makinenin kendi tahsilatı",
    MANUAL: "Elle kayıt",
};
export const WASH_CYCLE_STATUSES = ["COMPLETED", "ABORTED", "FAULT"];
export const washCycleStatusSchema = z.enum(WASH_CYCLE_STATUSES);
export const WASH_CYCLE_STATUS_LABELS = {
    COMPLETED: "Tamamlandı",
    ABORTED: "Yarıda kaldı",
    FAULT: "Arızayla bitti",
};
export const WASH_UNIT_STATES = ["IDLE", "RUNNING", "FAULT", "OFFLINE"];
export const washUnitStateSchema = z.enum(WASH_UNIT_STATES);
export const WASH_UNIT_STATE_LABELS = {
    IDLE: "Boşta",
    RUNNING: "Çalışıyor",
    FAULT: "Arızalı",
    OFFLINE: "Bağlantı yok",
};
export const WASH_ACTIVATION_METHODS = ["REMOTE", "CODE", "MANUAL"];
export const washActivationMethodSchema = z.enum(WASH_ACTIVATION_METHODS);
export const WASH_ACTIVATION_SOURCES = ["POS", "APP", "WEB"];
export const washActivationSourceSchema = z.enum(WASH_ACTIVATION_SOURCES);
export const WASH_ACTIVATION_SOURCE_LABELS = {
    POS: "Kasa",
    APP: "Müşteri uygulaması",
    WEB: "Web / tablet",
};
export const WASH_ACTIVATION_STATUSES = [
    "PENDING",
    "STARTED",
    "COMPLETED",
    "FAILED",
    "EXPIRED",
    "CANCELLED",
];
export const washActivationStatusSchema = z.enum(WASH_ACTIVATION_STATUSES);
export const WASH_ACTIVATION_STATUS_LABELS = {
    PENDING: "Bekliyor",
    STARTED: "Başladı",
    COMPLETED: "Tamamlandı",
    FAILED: "Başlatılamadı",
    EXPIRED: "Süresi doldu",
    CANCELLED: "İptal edildi",
};
export const WASH_CREDIT_ENTRY_TYPES = ["PURCHASE", "USAGE", "ADJUST", "EXPIRE"];
export const washCreditEntryTypeSchema = z.enum(WASH_CREDIT_ENTRY_TYPES);
export const WASH_CREDIT_ENTRY_TYPE_LABELS = {
    PURCHASE: "Satın alma",
    USAGE: "Kullanım",
    ADJUST: "Düzeltme",
    EXPIRE: "Süre sonu",
};
export const WASH_CREDIT_STATUSES = ["ACTIVE", "EXPIRED", "BLOCKED"];
export const washCreditStatusSchema = z.enum(WASH_CREDIT_STATUSES);
export const WASH_CREDIT_STATUS_LABELS = {
    ACTIVE: "Etkin",
    EXPIRED: "Süresi doldu",
    BLOCKED: "Kilitli",
};
export const WASH_APPOINTMENT_STATUSES = ["BOOKED", "CHECKED_IN", "CANCELLED", "NO_SHOW"];
export const washAppointmentStatusSchema = z.enum(WASH_APPOINTMENT_STATUSES);
export const WASH_APPOINTMENT_STATUS_LABELS = {
    BOOKED: "Randevulu",
    CHECKED_IN: "Geldi (iş emri açıldı)",
    CANCELLED: "İptal",
    NO_SHOW: "Gelmedi",
};
export const WASH_WORK_ORDER_STATUSES = [
    "WAITING",
    "IN_PROGRESS",
    "READY",
    "DELIVERED",
    "CANCELLED",
];
export const washWorkOrderStatusSchema = z.enum(WASH_WORK_ORDER_STATUSES);
export const WASH_WORK_ORDER_STATUS_LABELS = {
    WAITING: "Bekliyor",
    IN_PROGRESS: "İşlemde",
    READY: "Hazır",
    DELIVERED: "Teslim edildi",
    CANCELLED: "İptal",
};
export const WASH_PHOTO_PHASES = ["BEFORE", "AFTER"];
export const washPhotoPhaseSchema = z.enum(WASH_PHOTO_PHASES);
export const WASH_PHOTO_PHASE_LABELS = { BEFORE: "Önce", AFTER: "Sonra" };
export const WASH_READY_SMS_STATUSES = ["NOT_SENT", "SENT", "FAILED", "NO_PHONE"];
export const washReadySmsStatusSchema = z.enum(WASH_READY_SMS_STATUSES);
export const WASH_READY_SMS_STATUS_LABELS = {
    NOT_SENT: "Gönderilmedi",
    SENT: "Gönderildi",
    FAILED: "Gönderilemedi",
    NO_PHONE: "Telefon yok",
};
/** Makinenin KENDİ tahsilatındaki ödeme türü (gün kapanışı `WASH_MACHINE_COLLECTION:{CASH|CARD}`). */
export const WASH_MACHINE_PAYMENT_TYPES = ["CASH", "CARD"];
export const washMachinePaymentTypeSchema = z.enum(WASH_MACHINE_PAYMENT_TYPES);
//# sourceMappingURL=enums.js.map